import { render, staticRenderFns } from "./InformationsStage.vue?vue&type=template&id=6d336808"
import script from "./InformationsStage.vue?vue&type=script&lang=js"
export * from "./InformationsStage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports